/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Steps_Scene_TitleInputs */

const en_road_dude_steps_scene_title = /** @type {(inputs: Road_Dude_Steps_Scene_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the scene at the window`)
};

const zh_road_dude_steps_scene_title = /** @type {(inputs: Road_Dude_Steps_Scene_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留车窗视角`)
};

/**
* | output |
* | --- |
* | "Set the scene at the window" |
*
* @param {Road_Dude_Steps_Scene_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_steps_scene_title = /** @type {((inputs?: Road_Dude_Steps_Scene_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Steps_Scene_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_steps_scene_title(inputs)
	return zh_road_dude_steps_scene_title(inputs)
});
export { road_dude_steps_scene_title as "road_dude.steps.scene.title" }